import { render } from "./Forum-main.vue?vue&type=template&id=410fb428&scoped=true&lang=pug"
import script from "./Forum-main.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-main.vue?vue&type=script&setup=true&lang=js"

import "./Forum-main.vue?vue&type=style&index=0&id=410fb428&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410fb428"]])

export default __exports__